/*-----------------------------------------------------------------------------/
/ Custom Theme JS
/-----------------------------------------------------------------------------*/

// Insert any custom theme js here...

/* ===========================================================================
   PBS-CUSTOM #10 / #11 — compare-at strikethrough totals in the cart

   Liquid renders the correct values on every server render (page load, reload,
   navigation). But Venue updates the cart with JS from /cart.js — which does not
   carry the product's compare-at price — so when a shopper adds an item or
   changes a quantity we recompute here, off Venue's `on:cart:loaded` event.

   Compare-at unit price per line, in order of preference:
     1. `item.compare_at_price` from the cart JSON, if present
     2. `data-pbs-compare-unit` on a server-rendered <cart-item> (has data-pbs-compare-ready)
     3. a one-off fetch of /products/{handle}.js (cached), for freshly added items
   =========================================================================== */
(function () {
  var productCache = {}; // handle -> { variantId: compareAtPriceCents }

  // Mirrors Venue's own formatMoney (assets/utils.lib.js) so our figures match
  // the theme's number formatting exactly. utils.lib.js only exports as an ES
  // module, so we can't import it from this plain script.
  function pbsMoney(cents, format) {
    format = format || (window.theme && window.theme.money_format) || 'CHF {{amount_no_decimals}}';
    if (cents == null || isNaN(cents)) cents = 0;
    var token = (format.match(/\{\{\s*(\w+)\s*\}\}/) || [null, 'amount'])[1];
    function sep(num, decimals, thousands, decimalSep) {
      var parts = (num / 100).toFixed(decimals).split('.');
      return parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands) +
        (parts[1] ? decimalSep + parts[1] : '');
    }
    var value;
    switch (token) {
      case 'amount_no_decimals': value = sep(cents, 0, ',', '.'); break;
      case 'amount_with_comma_separator': value = sep(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = sep(cents, 0, '.', ','); break;
      default: value = sep(cents, 2, ',', '.');
    }
    return format.replace(/\{\{\s*\w+\s*\}\}/, value);
  }

  function cssEscape(s) {
    return (window.CSS && CSS.escape) ? CSS.escape(String(s)) : String(s).replace(/["\\]/g, '\\$&');
  }

  function fetchProductCompareMap(handle) {
    if (!handle) return Promise.resolve({});
    if (productCache[handle]) return Promise.resolve(productCache[handle]);
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    productCache[handle] = fetch(root + 'products/' + handle + '.js')
      .then(function (r) { return r.json(); })
      .then(function (p) {
        var map = {};
        (p.variants || []).forEach(function (v) { map[v.id] = v.compare_at_price || 0; });
        productCache[handle] = map;
        return map;
      })
      .catch(function () { productCache[handle] = {}; return {}; });
    return productCache[handle];
  }

  function resolveUnit(item) {
    if (item.compare_at_price) return Promise.resolve(item.compare_at_price);
    var el = document.querySelector('cart-item[key="' + cssEscape(item.key) + '"][data-pbs-compare-ready]');
    if (el) return Promise.resolve(parseInt(el.getAttribute('data-pbs-compare-unit') || '0', 10) || 0);
    return fetchProductCompareMap(item.handle).then(function (map) { return map[item.variant_id] || 0; });
  }

  function applyCompare(cart) {
    if (!cart || !Array.isArray(cart.items)) return;

    Promise.all(cart.items.map(function (item) {
      return resolveUnit(item).then(function (unit) { return { item: item, unit: unit }; });
    })).then(function (rows) {
      var subtotalCompare = 0;

      rows.forEach(function (row) {
        var item = row.item;
        var unit = row.unit;
        var onSale = unit > 0 && unit > item.price;
        subtotalCompare += onSale ? unit * item.quantity : item.original_line_price;

        document.querySelectorAll('cart-item[key="' + cssEscape(item.key) + '"]').forEach(function (el) {
          el.setAttribute('data-pbs-compare-unit', unit);
          el.setAttribute('data-pbs-compare-ready', '1');
          var s = el.querySelector('.pbs-line-compare');
          if (!s) return;
          if (onSale) {
            s.textContent = pbsMoney(unit * item.quantity);
            s.hidden = false;
          } else {
            s.hidden = true;
          }
        });
      });

      var totalFormat = (window.theme && window.theme.money_total_price_format) || undefined;
      document.querySelectorAll('.pbs-subtotal-compare').forEach(function (s) {
        if (subtotalCompare > cart.total_price) {
          s.textContent = pbsMoney(subtotalCompare, totalFormat);
          s.hidden = false;
        } else {
          s.hidden = true;
        }
      });
    });
  }

  document.addEventListener('on:cart:loaded', function (e) {
    applyCompare(e.detail && e.detail.cart);
  });

  // On page load, normalise the values off the embedded cart JSON (<script id="cart-data">,
  // {{ cart | json }}). No network — server-rendered <cart-item>s already carry the
  // compare-at price in data-pbs-compare-unit.
  function initFromEmbeddedCart() {
    var el = document.getElementById('cart-data');
    if (!el) return;
    try { applyCompare(JSON.parse(el.textContent)); } catch (err) { /* ignore */ }
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initFromEmbeddedCart);
  } else {
    initFromEmbeddedCart();
  }
})();
